import { forceClearCacheAndReload } from '@/pwa'
import mixpanel from '@/services/mixpanel'
import { useAuthStore } from '@/stores/authStore'
export const getInitials = (name) => {
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase()
    .slice(0, 2)
}

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-NG', { style: 'currency', currency: 'NGN' }).format(amount)
}

export function formatDate(date) {
  return new Date(date).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

export function formatTime(date) {
  return new Date(date).toLocaleString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}
export function formatDateTime(date) {
  return new Date(date).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  })
}

export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export const clearCacheAndReload = async () => {
  const user = useAuthStore().user;
  mixpanel.track('Clear Cache & Reload', { distinct_id: user.id })
  await forceClearCacheAndReload()
}
